import script from "./TagsInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagsInput.vue?vue&type=script&lang=ts&setup=true"

import "./TagsInput.vue?vue&type=style&index=0&id=5d61fa14&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d61fa14"]])

export default __exports__